
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './Components/Home';
import { abpnClient } from './Services/AbpnClient';
import { ApplicationPaths } from './Services/Auth/AuthConstants';
import ApiAuthorizationRoutes from './Components/ApiAuthorizationRoutes';
import { OnBehalfOf } from './Components/Auth/OnBehalfOf';
import { appInsights } from './Services/AppInsights';
import Layout from './Components/Layout';
import '../src/App.scss'
import ErrorPage from './Components/ErrorPage';
import AvailableApplicationGrid from './Components/Dashboard/Applications/Components/AvailableApplicationGrid';
import { AuthorizeRoute } from './Components/Auth/AuthorizeRoute';
import { AuthProvider } from './Components/Auth/AuthProvider';
import { StaffOnlyRoute } from './Components/Auth/StaffOnlyRoute';
import Application from './Components/Apply/Components/Application';
import ExaminationReport from './Components/Examination/ExaminationReport';
import ExamHistory from './Components/Examination/ExamHistory';
import Unauthorized from './Components/Unauthorized';
import ManageActivities from './Components/ManageActivities/ManageActivities';
import { EmailNotFound } from './Components/Auth/EmailNotFound';
import AccountInformation from './Components/Account/AccountInformation';
import SearchForAccount from './Components/Auth/SearchForAccount';
import PersonalInformation from './Components/Auth/PersonalInformation';
import ManageCCEnrollment from './Components/CCEnrollment/Components/ManageCCEnrollment';
import { ProfileProvider } from './Components/Auth/ProfileProvider';
import OtherBoardHome from './Components/OtherBoardHome';
import PaymentsAndReceipts from './Components/PaymentsAndReceipts';
import Messages from './Components/Messages/Components/Messages';

function App() {
  appInsights.load();

  const basename = '/physicianportal'
  const errorPageUrl = `${basename}/error`;

  abpnClient.setErrorPage(errorPageUrl);

  return (
    <AuthProvider errorPage={errorPageUrl}>
      <ProfileProvider>
        <Router basename={basename}>
          <Layout>
            <Switch>
              <Route exact path='/error/:errorId?' component={ErrorPage} />
              <Route exact path='/emailnotfound' component={EmailNotFound} />
              <Route exact path='/unauthorized' component={Unauthorized} />
              <Route exact path='/PersonalInformation' component={PersonalInformation}></Route>
              <StaffOnlyRoute path='/onbehalfof/:physicianId' component={OnBehalfOf} />
              <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
              <Route exact={true} path={ApplicationPaths.SearchForAccount} component={SearchForAccount} />
              <AuthorizeRoute exact path='/' component={Home} />
              <AuthorizeRoute exact path='/AccountInformation' component={AccountInformation} />
              <AuthorizeRoute exact path='/ManageActivities' component={ManageActivities} />
              <AuthorizeRoute exact path='/AvailableExaminations' component={AvailableApplicationGrid}></AuthorizeRoute>
              <AuthorizeRoute exact path='/Apply/:examinationId' strict component={Application}></AuthorizeRoute>
              <AuthorizeRoute exact path='/ExaminationReport' component={ExaminationReport}></AuthorizeRoute>
              <AuthorizeRoute exact path='/ExaminationHistory' component={ExamHistory}></AuthorizeRoute>
              <AuthorizeRoute exact path='/PaymentsAndReceipts' component={PaymentsAndReceipts}></AuthorizeRoute>
              <AuthorizeRoute exact path='/Messages' component={Messages}></AuthorizeRoute>
              <AuthorizeRoute exact path='/ManageCCEnrollment' component={ManageCCEnrollment}></AuthorizeRoute>
              <AuthorizeRoute exact path='/OtherBoard' component={OtherBoardHome} />
            </Switch>
          </Layout>
        </Router>
      </ProfileProvider>
    </AuthProvider>);
}

export default App;
